import Api from './Api';

const END_POINT = 'dashboard';

export default {
    getMostSelledProducts(year, month) {
        let request = {
            params: {
                year_value: year,
                month_value: month                
            }
        }
        return Api.get(`${END_POINT}/most-selled-products`, request);
    },
    getSalesPerMonth(year) {
        let request = {
            params: {
                year_value: year              
            }
        }
        return Api.get(`${END_POINT}/sales-per-month`, request);
    },
    getProductionByAnalisys(form) {
        let request = {
            params: {
                ...form           
            }
        }
        return Api.get(`${END_POINT}/production-by-analisys`, request);
    },
    getAmountByAnalisys(form) {
        let request = {
            params: {
                ...form           
            }
        }
        return Api.get(`${END_POINT}/amount-by-analisys`, request);
    },
    getProductionByDoctor(form) {
        let request = {
            params: {
                ...form           
            }
        }
        return Api.get(`${END_POINT}/production-by-doctor`, request);
    },
    getAmountByDoctor(form) {
        let request = {
            params: {
                ...form           
            }
        }
        return Api.get(`${END_POINT}/amount-by-doctor`, request);
    },
    getAmountReferredByCustomers(form) {
        let request = {
            params: {
                ...form           
            }
        }
        return Api.get(`${END_POINT}/amount-referred-customers`, request);
    },
    getProductionByConvenio(form) {
        let request = {
            params: {
                ...form           
            }
        }
        return Api.get(`${END_POINT}/production-by-convenio`, request);
    },
    getAmountOrdersByConvenio(form) {
        let request = {
            params: {
                ...form           
            }
        }
        return Api.get(`${END_POINT}/amount-order-by-convenio`, request);
    },
    getTotalSales(form) {
        let request = {
            params: {
                ...form           
            }
        }
        return Api.get(`${END_POINT}/total-sales`, request);
    },
    getTotalSalesAllOffice(form) {
        let request = {
            params: {
                ...form           
            }
        }
        return Api.get(`${END_POINT}/total-sales-all-office`, request);
    },
    getAmountAttention(form) {
        let request = {
            params: {
                ...form           
            }
        }
        return Api.get(`${END_POINT}/amount-attention`, request);
    },
    getAmountCortesias(form) {
        let request = {
            params: {
                ...form           
            }
        }
        return Api.get(`${END_POINT}/amount-cortesia`, request);
    },
    getAmountOrderDiscount(form) {
        let request = {
            params: {
                ...form           
            }
        }
        return Api.get(`${END_POINT}/amount-order-discount`, request);
    },
    getProductionAnalisysPromocional(form) {
        let request = {
            params: {
                ...form           
            }
        }
        return Api.get(`${END_POINT}/sale-analisys-promocianal`, request);
    },

}